import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconFuturesBot20pxRegular = function IconFuturesBot20pxRegular(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_6_3274)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.523 5.984a4.25 4.25 0 014.25-4.25h8.453a4.25 4.25 0 014.25 4.25v3.018a.75.75 0 11-1.5 0V5.984a2.75 2.75 0 00-2.75-2.75H5.773a2.75 2.75 0 00-2.75 2.75v8.035a2.75 2.75 0 002.75 2.75h1.608a.75.75 0 010 1.5H5.773a4.25 4.25 0 01-4.25-4.25V5.984z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.952 8.389a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.048 8.389a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.334 13.104a.8.8 0 00-.8.8v.582a.7.7 0 11-1.4 0v-.582a2.2 2.2 0 012.2-2.2h6.23a.7.7 0 01.495 1.195l-1.389 1.388a.7.7 0 11-.99-.99l.194-.193h-4.54zm6.379 1.764a.7.7 0 01.7.7v.642a2.2 2.2 0 01-2.2 2.2h-6.255a.7.7 0 01-.495-1.195l1.402-1.401a.7.7 0 01.99.99l-.207.206h4.565a.8.8 0 00.8-.8v-.642a.7.7 0 01.7-.7z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6_3274",
        children: /*#__PURE__*/_jsx("rect", {
          width: "20",
          height: "20"
        })
      })
    })]
  }));
};
export default IconFuturesBot20pxRegular;